export default function hiddenService() {
  return function generate(viewField, engineApi) {
    const model = engineApi.utils.getLastItems(viewField.model, 2);
    const defaultValue = engineApi.property.getDefaultValue(viewField);

    return (
      new engineApi.Element('input')
        .setType('hidden')
        // @odeniel sirve para crear un scope e isolarlo, sino impide que funcione bien el fb-register de los campos siguientes
        .addAttribute('ng-if', 'true')
        // @avaron: debido a que al editar, los campos se cargan con '', si el valor del modelo es string vacío ponemos el defaultValue
        .addAttribute('ng-init', `${model} = ${model} === undefined || ${model} === '' ? '${defaultValue}' : ${model}`)
    );
  };
}
